import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "privacy",
  "use": "privacy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"privacy\"><path d=\"M11.556 6.667V4.889A3.555 3.555 0 0 0 8 1.333 3.555 3.555 0 0 0 4.445 4.89v1.778H3.11v3.11a4.897 4.897 0 0 0 4.89 4.89 4.897 4.897 0 0 0 4.888-4.89v-3.11zM5.778 4.889a2.223 2.223 0 0 1 4.444 0v1.778H5.778zm5.778 4.889A3.555 3.555 0 0 1 8 13.333a3.555 3.555 0 0 1-3.555-3.555V8h7.11zm-4.222 1.555c0 .365.302.667.666.667a.67.67 0 0 0 .667-.667v-.844A.975.975 0 0 0 8 8.8a.975.975 0 0 0-.666 1.689z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol